export function getNavPath(path) {
  return path?.split('#')[0]?.replace(/\/$/, "")
}
export const removeTrailingSlash = (s) => {

  if (s && s.charAt(-1) === "/") s.subString(0, s.length-1)
  return s
}
export function matchNavPath(path, search, exact = false) {
  const source = getNavPath(path)
  if (search === '/') return source === '/'
  return exact ? removeTrailingSlash(source) === removeTrailingSlash(search) : source.startsWith(search)
}